import type { EffectDefinition } from "@/effects/types";

export const SATURATION_SHADER = "saturation";

function parseIntensity(effectParams: Record<string, unknown>): number {
	const raw = effectParams.intensity;
	return typeof raw === "number" ? raw : Number.parseFloat(String(raw));
}

/** intensity in [-100, 100], 0 = no change. Mapped to a saturation factor in [0, 2]: -100 is
 * fully grayscale, 100 is doubled saturation (matches saturation.wgsl). */
export function intensityToSaturationFactor(intensity: number): number {
	return 1 + intensity / 100;
}

export const saturationEffectDefinition: EffectDefinition = {
	type: "saturation",
	name: "Насыщенность",
	keywords: ["saturation", "color", "vibrance"],
	params: [
		{
			key: "intensity",
			label: "Интенсивность",
			type: "number",
			default: 0,
			min: -100,
			max: 100,
			step: 1,
		},
	],
	renderer: {
		passes: [
			{
				shader: SATURATION_SHADER,
				uniforms: ({ effectParams }) => ({
					u_amount: intensityToSaturationFactor(parseIntensity(effectParams)),
				}),
			},
		],
	},
};
